import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "@/hooks/useTranslation";

const Footer = () => {
  const { t } = useTranslation();

  const navigation = {
    product: [
      { name: t("footer.links.features"), href: "/features" },
      { name: t("footer.links.integrations"), href: "#" },
      { name: t("footer.links.pricing"), href: "/pricing" },
      { name: t("footer.links.faq"), href: "/faq" },
    ],
    company: [
      { name: t("footer.links.about"), href: "/about" },
      { name: t("footer.links.blog"), href: "/blog" },
      { name: t("footer.links.careers"), href: "/careers" },
      { name: t("footer.links.contact"), href: "/contact" },
    ],
    resources: [
      { name: t("footer.links.apiDocs"), href: "/api-documentation" },
      { name: t("footer.links.helpCenter"), href: "#" },
      { name: t("footer.links.support"), href: "#" },
    ],
    legal: [
      { name: t("footer.links.privacy"), href: "/privacy" },
      { name: t("footer.links.terms"), href: "/terms" },
      { name: t("footer.links.cookies"), href: "/cookies" },
    ],
  };

  return (
    <footer className="bg-gray-50 dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800">
      <div className="container mx-auto px-4 py-8 sm:py-12">
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-5 gap-6 sm:gap-8">
          <div className="col-span-2">
            <Link to="/">
              <img
                src="/HostCall-ai-logo-v3-transp.png"
                alt="HostCall.ai"
                width={117}
                height={32}
                className="h-7 sm:h-8 mb-3 sm:mb-4"
              />
            </Link>
            <p className="text-gray-600 dark:text-gray-400 mb-4 sm:mb-6 max-w-md text-sm sm:text-base">
              {t("footer.description")}
            </p>
            
            <div className="flex space-x-3 sm:space-x-4">
              <a href="#" className="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300">
                <span className="sr-only">Facebook</span>
                <svg className="h-5 w-5" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M13.818 2.294a1 1 0 01.795.315l.73 2.353c.086.277.27.505.518.653l2.153.93a1 1 0 01.593.941l-.783 2.243a1 1 0 01-.293.795l-1.915 1.675a1 1 0 01-.186.553l.45 2.307a1 1 0 01-.733 1.051l-2.03-.742a1 1 0 01-.593 0l-2.03.742a1 1 0 01-.733-1.051l.45-2.307a1 1 0 01-.187-.553L3.75 9.727a1 1 0 01-.293-.795l-.783-2.243a1 1 0 01.593-.941l2.153-.93c.248-.148.432-.376.518-.653l.73-2.353a1 1 0 01.795-.315h4.854zm-.332 5.961a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0z" clipRule="evenodd" />
                </svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300">
                <span className="sr-only">Twitter</span>
                <svg className="h-5 w-5" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M6.29 18.251c7.547 0 11.675-6.253 11.675-11.675 0-.178-.003-.355-.008-.53 1.002-.724 1.879-1.638 2.583-2.68-1.155.684-2.427 1.166-3.791 1.451a6.228 6.228 0 002.728-3.445c-1.192.703-2.517 1.141-3.923 1.403a6.04 6.04 0 00-10.878 5.834 6.4 6.4 0 00.721 1.542 11.03 11.03 0 01-8.464-4.307 6.049 6.049 0 001.88 8.087c-.984-.03-1.907-.301-2.758-.749a6.04 6.04 0 004.766 5.93 12.31 12.31 0 01-5.192 1.735 6.1 6.1 0 005.719 4.481 11.208 11.208 0 01-4.661 1.931c-.264 0-.529-.015-.793-.046a6.039 6.039 0 008.486 4.143z" />
                </svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300">
                <span className="sr-only">GitHub</span>
                <svg className="h-5 w-5" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 0C4.477 0 0 4.477 0 10c0 4.237 2.741 7.84 6.541 9.147.4.073.547-.174.547-.385 0-.19-.007-.693-.013-1.335-2.665.577-3.225-1.286-3.225-1.286-.438-1.101-1.063-1.39-1.063-1.39-.87-.593.065-.58.065-.58.963.068 1.469.986 1.469.986.855 1.449 2.248 1.026 2.807.396.087-.307.335-.562.608-.693-2.135-.24-4.37-.994-4.37-4.42 0-.977.35-1.78.932-2.404-.093-.24-.402-1.139.087-2.375 0 0 .762-.24 2.49.918a8.437 8.437 0 012.225-.3 8.437 8.437 0 012.225.3 2.49.918 0 002.49-.918c.489 1.236.18 2.135.087 2.375.582.624.932 1.427.932 2.404 0 3.431-2.239 4.182-4.383 4.42.342.291.63.852.63 1.723 0 1.247-.013 2.245-.013 2.549 0 .21.147.458.553.381C17.259 17.84 20 14.237 20 10c0-5.523-4.477-10-10-10z" clipRule="evenodd" />
                </svg>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-xs sm:text-sm font-semibold text-gray-900 dark:text-white uppercase tracking-wider mb-3 sm:mb-4">
              {t("footer.product")}
            </h3>
            <ul className="space-y-2">
              {navigation.product.map((item) => (
                <li key={item.name}>
                  <Link to={item.href} className="text-sm text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-xs sm:text-sm font-semibold text-gray-900 dark:text-white uppercase tracking-wider mb-3 sm:mb-4">
              {t("footer.company")}
            </h3>
            <ul className="space-y-2">
              {navigation.company.map((item) => (
                <li key={item.name}>
                  <Link to={item.href} className="text-sm text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-xs sm:text-sm font-semibold text-gray-900 dark:text-white uppercase tracking-wider mb-3 sm:mb-4">
              {t("footer.resources")}
            </h3>
            <ul className="space-y-2">
              {navigation.resources.map((item) => (
                <li key={item.name}>
                  <Link to={item.href} className="text-sm text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 dark:border-gray-800 mt-8 sm:mt-12 pt-6 sm:pt-8 flex flex-col-reverse sm:flex-row justify-between items-center gap-4">
          <p className="text-xs sm:text-sm text-gray-500 dark:text-gray-400 text-center sm:text-left">
            {t("footer.copyright")}
          </p>
          <div className="flex space-x-4 sm:space-x-6">
            <Link to="/privacy" className="text-xs sm:text-sm text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
              {t("footer.links.privacy")}
            </Link>
            <Link to="/terms" className="text-xs sm:text-sm text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
              {t("footer.links.terms")}
            </Link>
            <Link to="/cookies" className="text-xs sm:text-sm text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
              {t("footer.links.cookies")}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
